import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import FactFindFlow from './FactFindFlow';

type FactFindContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

const FactFindContext = createContext<FactFindContextType>({} as FactFindContextType);

export function useFactFind() {
  const context = useContext(FactFindContext);
  if (context === undefined) {
    throw new Error('useFactFind must be used within a FactFindProvider');
  }
  return context;
}

export default function FactFindProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open, close }] = useDisclosure(false);

  const value = {
    opened,
    open,
    close,
  };

  return (
    <FactFindContext.Provider value={value}>
      {children}
      <FactFindFlow opened={opened} close={close} />
    </FactFindContext.Provider>
  );
}
